import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import type { PeticaoModelo } from './ModelosPage';

interface ModeloDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  modelo: PeticaoModelo | null;
  onConfirm: () => Promise<void>;
  isPending: boolean;
}

export function ModeloDeleteDialog({ open, onOpenChange, modelo, onConfirm, isPending }: ModeloDeleteDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-full sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Mover para lixeira</DialogTitle>
          <DialogDescription>
            Tem certeza que deseja mover o modelo <strong>&ldquo;{modelo?.titulo}&rdquo;</strong> para a lixeira?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isPending}
          >
            {isPending ? 'Excluindo...' : 'Excluir'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
